import * as types from './mutation-types'

export default {
  [types.ADD_PAYMENTS](state, data) {
    state.payments = data
  },
  [types.ADD_PAYMENT] (state, data) {
    state.payments.push(data)
  },
  [types.ADD_PAYMENT_ENUMS] (state, data) {
    state.enums = data
  },
  [types.ADD_PAYMENT_STATUS_ENUMS] (state, data) {
    state.statusEnums = data
  },
}
